export class Contact {
    id: number | undefined;
    name: string | undefined;
    email: string | undefined;
    phone?: string | undefined;
    subject: string | undefined;
    message: string | undefined;
    recaptcha: string | undefined;
}
